import { Practitioner } from '../../../models/Entities/Practitioners/Practitioner';

/**
 * Un practitioner recién traído de Identity sobre el que ya estaba en el store.
 *
 * Identity sólo manda los datos de la persona: las asociaciones (prácticas, obras sociales, especialidades,
 * configuración, contrato) las cargan otras pantallas por separado y viven únicamente en el store. Cada
 * refresco del listado tiene que conservarlas, si no el selector de prácticas de la disponibilidad (y
 * cualquier otro que las lea del practitioner) se queda vacío cuando el listado vuelve a llegar.
 */
export const mergePractitioner = (incoming: Practitioner, current: Practitioner | undefined): Practitioner => {
  if (!current) return incoming;
  return {
    ...current,
    ...incoming,
    Settings: incoming.Settings ?? current.Settings,
    MedicalServicesAssociated: incoming.MedicalServicesAssociated ?? current.MedicalServicesAssociated,
    MedicalInsuranceAssociated: incoming.MedicalInsuranceAssociated ?? current.MedicalInsuranceAssociated,
    SpecialtiesAssociated: incoming.SpecialtiesAssociated ?? current.SpecialtiesAssociated,
    ContractAssociation: incoming.ContractAssociation ?? current.ContractAssociation,
  };
};

/** El listado recibido cruzado con el actual, por userId (sin distinguir mayúsculas), ordenado por nombre. */
export const mergePractitionerList = (incoming: Practitioner[] | undefined, current: Practitioner[] | undefined): Practitioner[] => {
  const byId = new Map((current ?? []).map((practitioner) => [practitioner.userId?.toLowerCase(), practitioner]));
  return (incoming ?? [])
    .map((practitioner) => mergePractitioner(practitioner, byId.get(practitioner.userId?.toLowerCase())))
    .sort((a, b) => (a.fullName ?? '').localeCompare(b.fullName ?? ''));
};
